import axios from 'utils/axios';
import {DutyEntity} from "../types/duty";

export const getDuty = async (specializationId: string): Promise<DutyEntity> => {
  const result = await axios.get(`/publicapi/v1/doctors/duties/${specializationId}`)
  return result.data.data as DutyEntity
}
